export default __webpack_public_path__ + "static/media/gallery6.64e39956.jpg";